<dialog-base [width]="25" [height]="20" [isError]="false">
  <div header-slot>{{ title }}</div>
  <div content-slot>
    <div>{{ message }}</div>
  </div>
  <div footer-slot class="dialog-buttons-container">
    <button type="button" class="btn btn-primary btn-primary-custom" (click)="confirm()">Tak</button>
    <button type="button" class="btn btn-secondary btn-secondary-custom" (click)="cancel()">Nie</button>
  </div>
</dialog-base>